module.exports = __webpack_public_path__ + "img/icon-3-white.ffab3722.png";